<template>
  <MenuButton
    :button-label="`${label}: ${selectedLabel}`"
    size="medium"
    :full-width="fullWidth"
    :mobile-sheet="mobileSheet"
    :sheet-title="label"
    v-bind="$attrs"
  >
    <MenuButtonItem
      v-for="option in options"
      :key="option.value"
      :title="option.label"
      :is-selected="option.value === modelValue"
      @click="emit('update:modelValue', option.value)"
    >
      <template v-if="option.count !== undefined" #suffix>
        <Text as="span" variant="label-small" color="tertiary">{{ option.count }}</Text>
      </template>
    </MenuButtonItem>
  </MenuButton>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import MenuButtonItem from '../menu-button/menu-button-item.vue';
import MenuButton from '../menu-button/menu-button.vue';
import Text from '../text.vue';

export interface FilterMenuOption {
  value: string;
  label: string;
  /** How many the choice would show, after its label */
  count?: number;
}

defineOptions({ inheritAttrs: false });

/**
 * One filter over a list: the trigger names the field and the choice ("Status: All"), the menu lists
 * every choice with its count and a check on the current one.
 */
const props = defineProps<{
  label: string;
  modelValue: string;
  options: FilterMenuOption[];
  fullWidth?: boolean;
  /** On a phone the choices open as a bottom sheet headed by the label */
  mobileSheet?: boolean;
}>();
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

// A value the options no longer offer reads as the first choice, which is the widest one by convention
const selectedLabel = computed(
  () => (props.options.find((option) => option.value === props.modelValue) ?? props.options[0])?.label ?? '',
);
</script>
